import React from "react";
import calendarIcon from "../../../assets/img/proicons_calendar.svg";
import moment from "moment";
import { dashboardColors, theme } from "../../../themes/Theme";

const DisplayCustomSelectedDate = ({ startDate = '', endDate = '' }) => {
    const startFormatted = startDate ? moment(startDate).format('DD MMM YYYY') : '';
    const endFormatted = endDate ? moment(endDate).format('DD MMM YYYY') : '';

    return (
        <div className="d-flex align-items-center richtext-gap-2 display-custom-selected-cont ">
            <img src={calendarIcon} alt="calendar" className="w-4 h-4" />
            <span>
                {startFormatted} – {endFormatted}
            </span>
            <style>{
                `
                .display-custom-selected-cont{
                    padding:4px 10px;
                    border: 1px solid #C3CDDF;
                    font-size:14px;
                    font-weight:500;
                    color: ${dashboardColors[theme].primaryTextColor};
                    border-radius: 20px;
                    width: fit-content;
                }  
                
                `
            }</style>
        </div>
    );
};

export default DisplayCustomSelectedDate;
